import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { useAuthStore } from "../stores/auth";
import { AuthShell } from "./LoginPage";

export function SelectTenantPage() {
  const { memberships, selectTenant } = useAuthStore();
  const navigate = useNavigate();
  const [pending, setPending] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  async function pick(tenantId: string) {
    setError(null);
    setPending(tenantId);
    try {
      await selectTenant(tenantId);
      navigate("/", { replace: true });
    } catch {
      setError("Impossible de sélectionner ce tenant");
    } finally {
      setPending(null);
    }
  }

  return (
    <AuthShell title="Choisir un tenant" subtitle="HInvoice">
      <p className="text-sm text-slate-600 mb-4">
        Votre compte est rattaché à plusieurs entités. Choisissez celle sur
        laquelle vous souhaitez travailler.
      </p>
      <ul className="space-y-3">
        {memberships.map((m) => (
          <li key={m.tenant.id}>
            <button
              type="button"
              disabled={pending !== null}
              onClick={() => pick(m.tenant.id)}
              className="w-full flex items-center justify-between px-4 py-3 border border-slate-200 rounded-lg hover:border-brand-500 hover:bg-brand-50 transition"
            >
              <span>
                <span className="font-medium text-slate-900">
                  {m.tenant.name}
                </span>
                <span className="block text-xs text-slate-500 mt-0.5">
                  {m.tenant.country} · {m.role}
                </span>
              </span>
              <span className="text-brand-600 text-sm">
                {pending === m.tenant.id ? "…" : "Ouvrir →"}
              </span>
            </button>
          </li>
        ))}
      </ul>
      {error && (
        <p role="alert" className="text-sm text-red-600 mt-3">
          {error}
        </p>
      )}
    </AuthShell>
  );
}
